export default function HideUIPropPreview() {
  return <>hello world</>;
}
